import { render, staticRenderFns } from "./ProductDetailDialog.vue?vue&type=template&id=1540301c&scoped=true"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailDialog.vue?vue&type=style&index=0&id=1540301c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540301c",
  null
  
)

export default component.exports